import './actions-disabled-overlay.scss';

interface Props {}

const ActionsDisabledOverlay: React.FC<Props> = (): JSX.Element => (
    <div className='actions-disabled-overlay'/>
);

export default ActionsDisabledOverlay;
